routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider   
    .state('workplan.projectProposalFormulation', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/projectFormulation',
      template: require('./projectFormulation/list/projectFormulationProposalsList.html'),
      controller: 'ProjectFormulationProposalsListCtrl',
      controllerAs: 'projectVM',
      data: {
        displayName: 'Formulación de propuesta',
        title: 'Extensión y visibilidad',
        order: 2,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning,
      }
    })

    .state('workplan.extensionAndVisibility', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/projectFormulation',
      template: require('./projectFormulation/list/projectFormulationProposalsList.html'),
      controller: 'ProjectFormulationProposalsListCtrl',
      controllerAs: 'projectVM',
      data: {
        displayName: 'Extensión y visibilidad',
        title: 'Extensión y visibilidad',
        order: 2,
        siblings: [
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning,
      }
    })

    .state('workplan.createProjectFormulationProposal', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/createProjectFormulationProposal/:workplanTeacherActivityId',
      template: require('./projectFormulation/create/createProjectFormulationProposal.html'),
      controller: 'CreateProjectFormulationProposalCtrl',
      controllerAs: 'createProjectFormulationProposalVm',
      data: {
        displayName: 'Formulación de propuesta',
        title: 'Extensión y visibilidad',
        order: 2,
        siblings: [
          {
              name: 'fullscreen.workPlanGeneralInformation',
              order: 0
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })

    .state('workplan.extensionProjects', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/extensionProjects',
      template: require('./extensionProjects/list/extensionProjectsList.html'),
      controller: 'ExtensionProjectsListCtrl',
      controllerAs: 'extensionVM',
      data: {
        displayName: 'Proyectos de extensión',
        title: 'Extensión y visibilidad',
        order: 3,
        siblings: [
          {
              name: 'fullscreen.workPlanGeneralInformation',
              order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })
 
    .state('workplan.createExtensionProject', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/createExtensionProject/:workplanTeacherActivityId',
      template: require('./extensionProjects/create/createExtensionProject.html'),
      controller: 'CreateExtensionProjectCtrl',
      controllerAs: 'createExtensionProjectVm',
      data: {
        displayName: 'Proyectos de extensión',
        title: 'Extensión y visibilidad',
        order: 3,
        siblings: [
          {
              name: 'fullscreen.workPlanGeneralInformation',
              order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
       params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })

    .state('workplan.visibilityAndComunication', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/visibilityAndComunication',
      template: require('./visibility/list/visibilityList.html'),
      controller: 'VisibilityListCtrl',
      controllerAs: 'visibilityVM',
      data: {
        displayName: 'Visibilidad',
        title: 'Extensión y visibilidad',
        order: 4,
        siblings: [
          {
              name: 'fullscreen.workPlanGeneralInformation',
              order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })

    .state('workplan.createVisibility', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/createVisibility/:workplanTeacherActivityId',
      template: require('./visibility/create/createVisibility.html'),
      controller: 'CreateVisibilityCtrl',
      controllerAs: 'createVisibilityVm',
      data: {
        displayName: 'Visibilidad',
        title: 'Extensión y visibilidad',
        order: 4,
        siblings: [
          {
              name: 'fullscreen.workPlanGeneralInformation',
              order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })
   
    .state('workplan.counselingAndConsultancy', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/counselingAndConsultancy',
      views: {
          '': {
            template: require('./counselingAndConsultancy/list/index.html'),
          },
          'principal@': {
            template: require('./counselingAndConsultancy/list/counselingAndConsultancyList.html'),
            controller: 'CounselingAndConsultancyListCtrl',
            controllerAs: 'counselingAndConsultancyVm',         
          },
          'indicators@': {
            template: require('../indicators/indicators.html'),
            controller: 'IndicatorsCtrl',
            controllerAs: 'indicatorsVm',
        }
      },
        data: {
        displayName: 'Consultoría y asesoría',
        title: 'Extensión y Visibilidad',
        order: 5,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          }, 
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.shortCourses',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
  })


  .state('workplan.createCounselingAndConsultancy', {
    moduleId: GlobalConfig.modules.extentionAndVisibility,
    abstract: false,
    url: '/extensionVisibility/createCounselingAndConsultancy/:workplanTeacherActivityId',
    template: require('./counselingAndConsultancy/create/createCounselingAndConsultancy.html'),
    controller: 'CreateCounselingAndConsultancyCtrl',
    controllerAs: 'createCounselingAndConsultancyVm',
    data: {
      displayName: 'Consultoría y asesoría',
      title: 'Extensión y Visibilidad',
      order: 5,
      siblings: [
        {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
        },
        {
          name: 'workplan.projectProposalFormulation',
          order: 2
        },
        {
          name: 'workplan.extensionProjects',
          order: 3
        },
        {
          name: 'workplan.visibilityAndComunication',
          order: 4
        },
        {
          name: 'workplan.shortCourses',
          order: 6
        },
          {
            name: 'workplan.history',
            order: 7
          }
      ]
    },
    params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
  })

.state('workplan.shortCourses', {
      moduleId: GlobalConfig.modules.extentionAndVisibility,
      abstract: false,
      url: '/extensionVisibility/shortCourses',
      views: {
        '': {
          template: require('./shortCourses/list/index.html')
        },
        'principal@': {
          template: require('./shortCourses/list/shortCoursesList.html'),
          controller: 'ShortCoursesListCtrl',
          controllerAs: 'shortCoursesVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Educación continuada',
        order: 6,
        title: 'Extension y Visibilidad',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectProposalFormulation',
            order: 2
          },
          {
            name: 'workplan.extensionProjects',
            order: 3
          },
          {
            name: 'workplan.visibilityAndComunication',
            order: 4
          },
          {
            name: 'workplan.counselingAndConsultancy',
            order: 5
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
    })
   .state('workplan.createShortCourses', {
    moduleId: GlobalConfig.modules.extentionAndVisibility,
    abstract: false,
    url: '/extensionVisibility/createShortCourses/:workplanTeacherActivityId',
    template: require('./shortCourses/create/createShortCourses.html'),
    controller: 'CreateShortCoursesCtrl',
    controllerAs: 'createShortCourseVm',
    data: {
      displayName: 'Educación continuada',
      title: 'Extensión y Visibilidad',
      order: 6,
      siblings: [
        {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
        },
        {
          name: 'workplan.projectProposalFormulation',
          order: 2
        },
        {
          name: 'workplan.extensionProjects',
          order: 3
        },
        {
          name: 'workplan.visibilityAndComunication',
          order: 4
        },
        {
          name: 'workplan.counselingAndConsultancy',
          order: 5
        },
        {
          name: 'workplan.history',
          order: 7
        }
      ]
    },
    params: {
        indicatorType: GlobalConfig.indicatorsType.extension,
        stage: GlobalConfig.workplanStages.planning
      }
  })
  
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/extension.route.js